import React, { FunctionComponent, ReactNode } from 'react'
import { ExperimentProvider } from '@afterpaytouch/feature'
import { useAmplitudeWithEnduringEventProperties } from '../integrations/amplitude'

// Define portal-specific experiments
const PortalExperiments = {
  EnabledPortalSignup: 'rocketship.enabled-portal-signup',
  // Add other portal experiments here as needed
} as const

export type PortalExperimentName = keyof typeof PortalExperiments

interface PortalExperimentProviderProps {
  children: ReactNode
}

export const PortalExperimentProvider: FunctionComponent<PortalExperimentProviderProps> = ({ children }) => {
  const { logEvent } = useAmplitudeWithEnduringEventProperties()

  const config = {
    monitoring: logEvent,
    experiments: PortalExperiments,
    // No Redux dispatch needed for portal experiments
  }

  return <ExperimentProvider config={config}>{children}</ExperimentProvider>
}

export { PortalExperiments }
